import { TextField } from '@mui/material';
import { Box } from '@mui/system';
import { Subtopic } from '@shared/domain/subtopic/subtopic.aggregate';
import { SurveyOptionsValues } from '@shared/domain/survey/survey.aggregate';
import { validations } from '@shared/infrastructure/ui/validations';
import { Control, Controller } from 'react-hook-form';

export const SubtopicSurvey = ({
  control
}: {
  control: Control<Subtopic, any>;
}) => {
  return (
    <>
      <Controller
        name='survey.description'
        control={control}
        rules={validations.notWhiteSpace()}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
            sx={{ my: '0.3rem' }}
            label='Survey description'
            multiline
            minRows={2}
          />
        )}
      />
      {[
        {
          name: 'Great',
          label: "'Great' option",
          placeholder: 'This is a great idea'
        },
        {
          name: 'Promising',
          label: "'Promising' option",
          placeholder: 'It looks promising'
        },
        {
          name: 'NoValue',
          label: "'No value' option",
          placeholder: "I'm not sure about it"
        },
        {
          name: 'BadIdea',
          label: "'Bad idea' option",
          placeholder: "I wouldn't use this"
        }
      ].map((option) => (
        <Controller
          key={option.name}
          name={`survey.options.${option.name as SurveyOptionsValues}`}
          control={control}
          rules={validations.notWhiteSpace()}
          render={({ field, fieldState }) => (
            <TextField
              {...field}
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              sx={{ my: '0.3rem' }}
              label={option.label}
              placeholder={option.placeholder}
            />
          )}
        />
      ))}
    </>
  );
};
